// Set the options to make LazyLoad self-initialize
window.lazyLoadOptions = {
  elements_selector: '.lazy',
  // vertical offset before image, px
  // 1 screen by height
  threshold: window.innerHeight,
  load_delay: 0
};

// Listen to the initialization event and get the instance of LazyLoad
window.addEventListener('LazyLoad::Initialized', function (event) {
  window.lazyLoadInstance = event.detail.instance;
}, false);

